export default __webpack_public_path__ + "static/media/circular-book.3e3e677e.woff";